import { Component, Inject, OnDestroy, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { XeroService } from '../../../../../shared/services/xero.service';
import { UntypedFormControl, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { XeroAccount } from '../../../../../models/xero/xero-account';
import { MatButton } from '@angular/material/button';
import { MatInput } from '@angular/material/input';
import { MatOption } from '@angular/material/core';
import { NgIf } from '@angular/common';
import { MatSelect } from '@angular/material/select';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { FlexModule } from '@angular/flex-layout';

@Component({
    selector: 'new-account-dialog',
    templateUrl: './new-account-dialog.component.html',
    providers: [XeroService],
    standalone: true,
    imports: [FlexModule, ReactiveFormsModule, MatDialogTitle, MatDialogContent, MatFormField, MatLabel, MatSelect, NgIf, MatOption, MatInput, MatDialogActions, MatButton]
})
export class NewAccountDialogComponent implements OnDestroy {
  private ngUnsubscribe = new Subject<void>();
  accountMappingsForm = new UntypedFormGroup({});
  form = new UntypedFormGroup({
    name: new UntypedFormControl(null, Validators.required),
    bankAccountNumber: new UntypedFormControl(null, Validators.required),
    type: new UntypedFormControl(null, Validators.required),
    code: new UntypedFormControl(null, Validators.required),
    description: new UntypedFormControl(null)
  });
  xeroError;
  @ViewChild('stepper', { static: true }) stepper: MatStepper;

  constructor(
    public dialogRef: MatDialogRef<NewAccountDialogComponent>,
    private xeroService: XeroService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.setDefaultType();
  }

  submit() {
    this.xeroService
      .createXeroAccount(this.form.value)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        ({ account }: { account: XeroAccount }) => {
          this.dialogRef.close(account);
        },
        (error) => {
          if (error.error.xeroError) {
            this.xeroError = error.error.xeroError;
          }
          throw error;
        }
      );
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private setDefaultType() {
    if (this.data.type) {
      this.form.get('type').patchValue(this.data.type);
    }
  }
}
